import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { UserNotificationSettings } from './user-notification-settings.entity';

export class CreateUserNotificationSettingsDto extends Omit(UserNotificationSettings, BaseEntityFieldsArray) {}
